<template>
  <div id="app">
    <router-view/>
    <!-- AI 客服助手 -->
    <!-- <AiAssistant v-if="showAiAssistant" /> -->
  </div>
</template>

<script>
// import AiAssistant from '@/components/AiAssistant/index.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'App',
  components: {
    // AiAssistant,
  },
  computed: {
    ...mapGetters(['userinfo', 'userinfo2']),
    // 只在登录后显示 AI 助手
    showAiAssistant() {
      const user = Object.keys(this.userinfo2).length !== 0 ? this.userinfo2 : this.userinfo;
      return user && user.userid;
    },
  },
};
</script>

<style>
#app{
  height: 100%;
  width: 100%;
}

/* 账户列表标题样式 */
.title_examine{
 width: 100%;
 height: 75px;
 background-color: #fff;
 border-radius: 8px;
 padding: 10px 20px;
 box-sizing: border-box;
 display: flex;
 align-items: center;
}

.pub_title{
  font-size: 24px;
  font-weight: 400;
}
</style>
